import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"

export type DefaultTemplateCountryLangSelectorButtonContainerType = {
    applyMarginCompensation?: boolean
    openDrawer: (boolean) => void
    territory: string
    iconUrl: string
    isSecure?: boolean
}

export type CountryLangSelectorType = {
    territory: string
    iconUrl: string
    openDrawer: (boolean) => void
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    applyMarginCompensation?: boolean
    isSecure?: boolean
}

export const CountryLangSelectorButton = memo(
    ({territory, iconUrl, openDrawer, templating, applyMarginCompensation, isSecure}: CountryLangSelectorType) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        return (
            <Suspense>
                <ComponentName
                    id="header-country-selector-flag"
                    applyMarginCompensation={applyMarginCompensation}
                    openDrawer={openDrawer}
                    territory={territory}
                    iconUrl={iconUrl}
                    isSecure={isSecure}
                />
            </Suspense>
        )
    },
)
CountryLangSelectorButton.displayName = "CountryLangSelectorButton"

export default CountryLangSelectorButton
